module.exports = __webpack_public_path__ + "img/violet_089.0ba7528b.png";